// Helper for private fields
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => {
  if (member.has(obj)) return member.has(obj);
  else return __typeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => (member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value));
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

/* ---------------------------------------------
 *  StyledAs Web Component
 * --------------------------------------------- */
var _modal,
  _galleryItems,
  _mediaCarousel,
  _mediaItems,
  _infoItems,
  _prevBtn,
  _nextBtn,
  _closeBtn,
  _currentIndex,
  _StyledAs_instances,
  attachEvents_fn,
  openModal_fn,
  closeModal_fn,
  onSlideChange_fn,
  onPrev_fn,
  onNext_fn;

export class StyledAs extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _StyledAs_instances);
    __privateAdd(this, _modal, null);
    __privateAdd(this, _galleryItems, []);
    __privateAdd(this, _mediaCarousel, null);
    __privateAdd(this, _mediaItems, []);
    __privateAdd(this, _infoItems, []);
    __privateAdd(this, _prevBtn, null);
    __privateAdd(this, _nextBtn, null);
    __privateAdd(this, _closeBtn, null);
    __privateAdd(this, _currentIndex, 0);
  }

  connectedCallback() {
    __privateSet(this, _modal, this.querySelector("x-modal"));
    __privateSet(this, _galleryItems, Array.from(this.querySelectorAll(".sa-entry-container")));

    // Modal contents
    const modalEl = __privateGet(this, _modal);
    if (modalEl) {
      __privateSet(this, _mediaCarousel, modalEl.querySelector("scroll-carousel"));
      __privateSet(this, _mediaItems, Array.from(modalEl.querySelectorAll(".sa-modal-media-item")));
      __privateSet(this, _infoItems, Array.from(modalEl.querySelectorAll(".sa-modal-info-item")));
      __privateSet(this, _prevBtn, modalEl.querySelector(".sa-modal-prev"));
      __privateSet(this, _nextBtn, modalEl.querySelector(".sa-modal-next"));
      __privateSet(this, _closeBtn, modalEl.querySelector(".styled-as-modal__close"));
    }

    // Initialize Variant Pickers
    const itemCards = this.querySelectorAll(".sa-item-card");
    itemCards.forEach((card) => {
      try {
        new StyleAsVariantPicker(card);
      } catch (e) {
        console.warn("StyleAsVariantPicker init failed:", e);
      }
    });

    __privateMethod(this, _StyledAs_instances, attachEvents_fn).call(this);
  }
}

_modal = new WeakMap();
_galleryItems = new WeakMap();
_mediaCarousel = new WeakMap();
_mediaItems = new WeakMap();
_infoItems = new WeakMap();
_prevBtn = new WeakMap();
_nextBtn = new WeakMap();
_closeBtn = new WeakMap();
_currentIndex = new WeakMap();
_StyledAs_instances = new WeakSet();

attachEvents_fn = function () {
  // Gallery Click Events
  __privateGet(this, _galleryItems).forEach((item, index) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      // to enable tracking do not stop propagation
      // e.stopPropagation();
      __privateMethod(this, _StyledAs_instances, openModal_fn).call(this, index);
    });
  });

  // Modal Navigation
  const prevBtn = __privateGet(this, _prevBtn);
  const nextBtn = __privateGet(this, _nextBtn);
  const closeBtn = __privateGet(this, _closeBtn);
  const carousel = __privateGet(this, _mediaCarousel);

  if (prevBtn) prevBtn.addEventListener("click", __privateMethod(this, _StyledAs_instances, onPrev_fn).bind(this));
  if (nextBtn) nextBtn.addEventListener("click", __privateMethod(this, _StyledAs_instances, onNext_fn).bind(this));

  // Carousel Change Event
  if (carousel) {
    carousel.addEventListener("carousel:change", (event) => {
      const index = event.detail.index;
      __privateSet(this, _currentIndex, index);
      __privateMethod(this, _StyledAs_instances, onSlideChange_fn).call(this, index);
    });
  }

  // Close events
  if (closeBtn) {
    closeBtn.addEventListener("click", __privateMethod(this, _StyledAs_instances, closeModal_fn).bind(this));
  }
};

openModal_fn = function (index) {
  __privateSet(this, _currentIndex, index);
  const modal = __privateGet(this, _modal);
  const carousel = __privateGet(this, _mediaCarousel);

  if (modal) {
    // already opened by x-modal, see theme
    // modal.show();
    if (carousel) {
      // Use requestAnimationFrame to ensure layout is ready
      requestAnimationFrame(() => {
        carousel.select(index, { instant: true });
        // Fallback to ensure it catches up if layout was delayed
        requestAnimationFrame(() => {
          carousel.select(index, { instant: true });
        });
      });
      // Manually trigger update in case carousel doesn't emit change if index is same (or on init)
      __privateMethod(this, _StyledAs_instances, onSlideChange_fn).call(this, index);
    }
  }
};

closeModal_fn = function () {
  const modal = __privateGet(this, _modal);
  if (modal) {
    modal.hide();
  }
};

onPrev_fn = function () {
  const carousel = __privateGet(this, _mediaCarousel);
  if (carousel) {
    carousel.previous();
  }
};

onNext_fn = function () {
  const carousel = __privateGet(this, _mediaCarousel);
  if (carousel) {
    carousel.next();
  }
};

onSlideChange_fn = function (index) {
  const infoItems = __privateGet(this, _infoItems);
  const mediaItems = __privateGet(this, _mediaItems);
  const total = mediaItems.length;

  const prevBtn = __privateGet(this, _prevBtn);
  const nextBtn = __privateGet(this, _nextBtn);

  if (prevBtn) {
    if (index === 0) {
      prevBtn.setAttribute("disabled", "");
    } else {
      prevBtn.removeAttribute("disabled");
    }
  }

  if (nextBtn) {
    if (index === total - 1) {
      nextBtn.setAttribute("disabled", "");
    } else {
      nextBtn.removeAttribute("disabled");
    }
  }

  // Update Info (Fade/Show)
  infoItems.forEach((item, i) => {
    if (i === index) {
      item.classList.add("active");
      item.style.opacity = "1";
      item.style.pointerEvents = "auto";
      item.style.position = "relative";
    } else {
      item.classList.remove("active");
      item.style.opacity = "0";
      item.style.pointerEvents = "none";
      item.style.position = "absolute";
    }
  });

  // Handle Video Play/Pause if needed
  mediaItems.forEach((item, i) => {
    const video = item.querySelector("video");
    if (video) {
      if (i === index) {
        video.play().catch(() => {});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    }
  });
};

if (!window.customElements.get("styled-as")) {
  window.customElements.define("styled-as", StyledAs);
}
